import { getAPNDetail } from "@axios/api.enroll";
import { FetchingOrgsTree } from "@redux/actions";
import { Alert, Layout, Space } from "antd";
import React from "react";
import { connect } from "react-redux";
import { NavLink, Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import { Dispatch } from "redux";
import { abmDepInfo, getAbmVppToken } from "../axios/api.app";
import { SiteHeader, SiteSider } from "../components";
import { RootStoreModel } from "../redux/reducers";
import GlobalCopilot from "../components/chat/GlobalCopilot"
import Copilot from "../components/chat/Copilot"
import "./home.scss";
import { routes } from "./routes";
import { createStyles } from 'antd-style';
import { Translation } from "react-i18next";

interface propsModel extends RouteComponentProps<any, any, any>  {
  tokenSuccess:boolean,
  menuKey:string,
}
const mapStatetoProps = (state: RootStoreModel) => ({
  tokenSuccess: state.userState.tokenSuccess,
  menuKey:state.userState.menuKey,
});
interface stateModel {
  showErrorInfo: boolean,
  currentAPNsDueDate: number,
  currentABMDueDate: number,
  currentVPPDueDate: number,
  noticeDays: number,
  vppValidity: boolean,
  copilotOpen: boolean
}

class HomePage extends React.Component<propsModel, stateModel> {

  constructor(props: any) {
    super(props);
    this.state = {
      showErrorInfo: false,
      currentAPNsDueDate: 10000,
      currentABMDueDate: 10000,
      currentVPPDueDate: 10000,
      noticeDays: 45,
      vppValidity: true,
      copilotOpen: false
    };
  }

  componentDidMount() {
    if(this.props.tokenSuccess){
      this.getAbmInfo();
      this.getApnInfo();
      this.getVppInfo();
    }
    
  }
  
  componentDidUpdate(prevProps: propsModel) {
    if(this.props.tokenSuccess != prevProps.tokenSuccess){
      this.getAbmInfo();
      this.getApnInfo();
      this.getVppInfo();
    }
  }
  getAbmInfo() {
    abmDepInfo().then(res => {
      if (res.length > 0) {
        var validity = true;
        var minDueDate = this.state.noticeDays+1;
        for (const item of res) {
          if (!item.validity) {
            validity = item.validity;
          }
          if (item.renewedBy) {
            minDueDate = Number(this.getDueDate(item.renewedBy)) <= minDueDate ? Number(this.getDueDate(item.renewedBy)) : minDueDate;   
          }
        }
        if (!validity) {
          this.setState({ showErrorInfo: true })
        }
        if (minDueDate <= this.state.noticeDays) {
          this.setState({ currentABMDueDate: minDueDate })
        }
      } else {
        this.setState({ showErrorInfo: false })
      }
    })
  }
  getApnInfo() {
    getAPNDetail().then(res => {
      if (res) {
        if (res.renewedBy) {
          this.setState({currentAPNsDueDate: Number(this.getDueDate(res.renewedBy))})
        }
      }
    })
  }
  getVppInfo() {
    getAbmVppToken().then(res => {
      if (res.length > 0) {
        var validity = true;
        var minDueDate = this.state.noticeDays+1;
        for (const item of res) {
          if (!item.validity) {
            validity = item.validity;
          }
          if (item.renewedBy) {
            minDueDate = Number(this.getDueDate(item.renewedBy)) <= minDueDate ? Number(this.getDueDate(item.renewedBy)) : minDueDate;   
          }
        }
        this.setState({vppValidity: validity});

        if (minDueDate <= this.state.noticeDays) {
          this.setState({ currentVPPDueDate: minDueDate })
        }
      }
      // if (res) {
      //   if (res.renewedBy) {
      //     this.setState({currentVPPDueDate: Number(this.getDueDate(res.renewedBy))})
      //   }
      //   this.setState({vppValidity: res.validity})
      // }
    })
  }

  getDueDate(str: string) {
    // eg: str="August 17 2023 - in 283 days"
    return str.includes("day") ? str.split(" ").reverse()[1] : ""
  }

  setCopilotOpen = (open: boolean) => {
    this.setState({ copilotOpen: open });
  }

  // goSettingAbm(){
  // }
  render() {
    return (
      <Layout className="homeLayout">
        <SiteHeader
          copilotOpen={this.state.copilotOpen} 
          setCopilotOpen={this.setCopilotOpen} 
        ></SiteHeader>
        {/* <GlobalCopilot></GlobalCopilot> */}
        <GlobalCopilot 
          copilotOpen={this.state.copilotOpen} 
          setCopilotOpen={this.setCopilotOpen} 
        />
        {/* <Copilot 
          copilotOpen={this.state.copilotOpen} 
          setCopilotOpen={this.setCopilotOpen}
        /> */}
        <Layout className="mainLayout">
          {(this.props.menuKey!=="Index" && this.props.menuKey !=="help") &&(<SiteSider ></SiteSider>)}
          <Layout>
            <div
            
              style={{
                flex: "1 1 auto",
                position: "relative",
                overflow: "auto",
                borderBottom: 'none',
                backgroundColor:"#F0F2F5"
              }}
            >

              <div className="contentLayout">
                {/* <ErrorHandler> */}
                {this.state.showErrorInfo &&(
                    <Translation>{t => {
                      return (
                        <Alert message={t("提示" )}
                          description={t("ABM/ASM中的token已被更新,同步功能受限,请重新从ABM/ASM下载的token,并上传")}
                          action={
                            <Space>
                              <NavLink to={{ pathname: `/home/enrollments/settings/apples/ABM`, state: { regisStatus: 2,step:2} }}>{t("去上传")}</NavLink>
                              {/* <Button size="small" variant="outlined" onClick={this.goSettingAbm}>
                                
                              </Button> */}
                            </Space>
                          }
                          type="error"
                          closable
                        />

                      )
                    }}</Translation>
                )}
                {this.state.currentABMDueDate <= this.state.noticeDays &&(
                  <Translation>{t => {
                    return (
                      <Alert message={t("提示" )}
                        description={`${t('您的ABM/ASM证书')}${this.state.currentABMDueDate < 1 ? t('已到期') : t('将在') + ' ' + this.state.currentABMDueDate + ' ' + t('天后到期')}, ${t('请尽快更新')}, ${t('过期后相关功能将受限')}`}
                        type="warning"
                        closable
                      />

                    )
                  }}</Translation>
                )}
                {this.state.currentAPNsDueDate <= this.state.noticeDays &&(
                  <Translation>{t => {
                    return (
                      <Alert message={t("提示" )}
                        description={`${t('您的APN证书')}${this.state.currentAPNsDueDate < 1 ? t('已到期') : t('将在') + ' ' + this.state.currentAPNsDueDate + ' ' + t('天后到期')}, ${t('请尽快更新')}. ${t('过期后将无法管控设备')}, ${t('需要重新注册设备')}`}
                        type="warning"
                        closable
                      />

                    )
                  }}</Translation>
                )}
                {!this.state.vppValidity && (
                  <Translation>{t => {
                    return (
                      <Alert message={t("提示" )}
                        description={`${t('您的VPP证书') + t('已到期')}`}
                        type="warning"
                        closable
                      />

                    )
                  }}</Translation>
                )}
                {this.state.vppValidity && (this.state.currentVPPDueDate <= this.state.noticeDays) && (
                  <Translation>{t => {
                    return (
                      <Alert message={t("提示" )}
                        description={`${t('您的VPP证书')}${this.state.currentVPPDueDate < 1 ? t('已到期') : t('将在') + ' ' + this.state.currentVPPDueDate + ' ' + t('天后到期')}, ${t('请尽快更新')}, ${t('过期后相关功能将受限')}`}
                        type="warning"
                        closable
                      />

                    )
                  }}</Translation>
                )}
                <Switch>
                  {routes.map(({ key, path, compoent }) => (
                    <Route key={key} path={path} component={compoent}></Route>
                  ))}
                  <Route path="*">
                    <Redirect to="/home/index" />
                  </Route>
                </Switch>
                {/* </ErrorHandler> */}
              </div>
            </div>
            {/* <SiteFooter></SiteFooter> */}
          </Layout>
        </Layout>
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchingOrgsTree: () => dispatch(FetchingOrgsTree()),
});
export default connect(mapStatetoProps, mapDispatchToProps)(HomePage);
